import clsx from "clsx";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import InputField from "./InputField";
import Checkbox from "./Checkbox";
import Radiobutton from "./Radiobutton";
import Select from "./Select";
import SelectButtons from "./SelectButtons";
import { AppContext } from "../../context/appContext";

type TProps = {
  config: any[];
  onSubmit: (val: any) => void;
  ButtonsComponent?: any;
}

function DefaultForm({onSubmit, config, ButtonsComponent}: TProps) {
  const {widgetConfig} = useContext(AppContext);
  const { register, handleSubmit, formState, control, watch, formState: { errors } } = useForm();
  
  const hasButtons = config.find((item) => item.tag === "buttons");
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="chat-form flex flex-col">
      {config.map((item: any, key: number) => {
        let Component = null;
        switch(item.tag) {
          case "input": Component = InputField; break;
          case "checkbox": Component = Checkbox; break;
          case "radiobuttons": Component = Radiobutton; break; //should change radiobutton
          case "selectbox": Component = Select; break;
          case "buttons": Component = SelectButtons; break;
        }
        return (
          <label key={key} className="chat-form-item">
            {!widgetConfig.hideInputLabel && item.label && 
              <div className="chat-form-label pr-2">{item.label}</div>
            }
            <Component 
              key={key} 
              input={item} 
              register={register}
              control={control}
              onSubmit={onSubmit}
              watch={watch}
              required
            />
          </label>
        )
      })}
      {!hasButtons && <ButtonsComponent formState={formState}/>}
    </form>
  )
}

export default DefaultForm;
